// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__EDNZP","flexContainer":"ProfileContent_flexContainer__cRtT1"};